'use client';

import { trackEvent } from '@/utils/analytics';
import { usePageViewTracking } from '@/utils/hooks';

interface ContentNavProps {
  className?: string;
  hasRoute?: boolean;
  hasItinerary?: boolean;
  hasInformation?: boolean;
}

export function ContentNav({
  className,
  hasRoute,
  hasItinerary,
  hasInformation,
}: ContentNavProps) {
  // Track page view for client components
  usePageViewTracking();

  const scrollToSection = (id: string, label: string) => {
    // Track navigation click
    trackEvent({
      action: 'trip_content_nav_click',
      category: 'navigation',
      label,
      value: 1,
    });

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={className}>
      <div className="sticky top-8">
        <div className="bg-white rounded-4xl p-6 shadow-sm">
          <h2 className="text-2xl font-[500] mb-6">Tour Overview</h2>
          <nav>
            <ul className="space-y-3">
              {hasRoute && (
                <li>
                  <button
                    type="button"
                    onClick={() => scrollToSection('route', 'Route Overview')}
                    className="text-gray-700 hover:text-accent transition-colors w-full text-left"
                  >
                    Route Overview
                  </button>
                </li>
              )}
              {hasItinerary && (
                <li>
                  <button
                    type="button"
                    className="text-gray-700 hover:text-accent transition-colors w-full text-left"
                    onClick={() =>
                      scrollToSection('itinerary', 'Day - by - Day Itinerary')
                    }
                  >
                    Day - by - Day Itinerary
                  </button>
                </li>
              )}
              {hasInformation && (
                <li>
                  <button
                    type="button"
                    className="text-gray-700 hover:text-accent transition-colors w-full text-left"
                    onClick={() =>
                      scrollToSection('information', 'Essential Trip Info')
                    }
                  >
                    Essential Trip Info
                  </button>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}
